import { createContext, useContext } from 'react'

interface MenuState {
    open: boolean
    setOpen: (open: boolean) => void
}

export const MenuContext = createContext<MenuState>({
    open: false,
    setOpen: () => undefined
})

export const useMenu = (): MenuState => useContext(MenuContext)
